(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-metaobject-carousel"] && !Shopify.designMode) return;
  try {
    
  /* MP Metaobject Carousel - Navigation */
  (function () {
    function initCarousel(trackEl) {
      if (!trackEl) return;

      const id = trackEl.id.replace('mp-carousel-track-', '');
      const section = trackEl.closest('.mp-carousel-section');
      if (!section) return;

      const prevBtn = section.querySelector(`[data-carousel-prev="${id}"]`);
      const nextBtn = section.querySelector(`[data-carousel-next="${id}"]`);

      if (!prevBtn && !nextBtn) return;

      function getScrollAmount() {
        const slide = trackEl.querySelector('.mp-carousel-slide');
        if (!slide) return 300;
        const gap = parseFloat(getComputedStyle(trackEl).gap) || 0;
        return slide.offsetWidth + gap;
      }

      function updateButtons() {
        const maxScroll = trackEl.scrollWidth - trackEl.clientWidth;
        if (prevBtn) prevBtn.disabled = trackEl.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = trackEl.scrollLeft >= maxScroll - 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          trackEl.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          trackEl.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      trackEl.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      /* Update on resize */
      const ro = new ResizeObserver(updateButtons);
      ro.observe(trackEl);
    }

    document.querySelectorAll('[id^="mp-carousel-track-"]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
